import { Box, styled } from '@mui/material';

export const ActionsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;

  .MuiSlider-root {
    width: 82px;
  }
`;
